'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.doRequest = doRequest;
exports.doGetRequest = doGetRequest;
exports.doPostRequest = doPostRequest;
exports.doPutRequest = doPutRequest;
exports.doHeadRequest = doHeadRequest;
exports.doDeleteRequest = doDeleteRequest;
exports.doSuccessfullRequest = doSuccessfullRequest;
exports.doUnsuccessfullRequest = doUnsuccessfullRequest;
exports.getQueryString = getQueryString;
exports.getQueryStrings = getQueryStrings;

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _util = require('@its/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAuthData = function getAuthData() {
  var authData = localStorage.getItem('authorizationData');
  return authData ? JSON.parse(authData) : {};
};

function doRequest(params) {
  // TODO : stub system
  if (process.env.demoMode) {
    var _ret = function () {
      var apiPath = process.env.stubs;
      return {
        v: new _bluebird2.default(function (resolve, reject) {
          var response = {};
          // TODO
          response.body = require(apiPath)(url.replace(/\//, '_'));
          response.body ? resolve(response) : reject(new Error());
        })
      };
    }();

    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
  } else {
    return new _bluebird2.default(function (resolve, reject) {
      var req = _superagent2.default[params.method](process.env.baseURL + params.url).accept('json');

      // default authentication

      var _getAuthData = getAuthData();

      var token = _getAuthData.token;

      if (token) {
        req.set('Authorization', 'Bearer ' + token);
      }

      if (params.headers) {
        req.set(params.headers);
      }

      if (params.withCredentials || process.env.auth.provider === 'ActiveDirectory') {
        req.withCredentials();
      }

      if (params.buffer) {
        req.buffer();
      }

      var auth = params.auth;

      if (auth) {
        req.auth(auth.user, auth.pass);
      }
      if (params.fields) {
        for (var i = 0; i < params.fields.length; i++) {
          if (params.fields[i]) {
            req.field(params.fields[i].name, params.fields[i].value);
          }
        }
      }
      if (params.attach) {
        for (var _i = 0; _i < params.attach.length; _i++) {
          if (params.attach[_i]) {
            req.attach(params.attach[_i].name, params.attach[_i].path, params.attach[_i].filename);
          }
        }
      }

      var configs = ['type', 'accept', 'send', 'query', 'timeout', 'redirects'];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = configs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _i2 = _step.value;

          if (params[_i2]) {
            req[_i2](params[_i2]);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      req.end(function (error, res) {
        error ? reject(error) : resolve(res);
      });
    });
  }
}

function doGetRequest(params) {
  return doRequest((0, _util.merge)(params, { method: 'get' }));
}

function doPostRequest(params) {
  return doRequest((0, _util.merge)(params, { method: 'post' }));
}

function doPutRequest(params) {
  return doRequest((0, _util.merge)(params, { method: 'put' }));
}

function doHeadRequest(params) {
  return doRequest((0, _util.merge)(params, { method: 'head' }));
}

function doDeleteRequest(params) {
  return doRequest((0, _util.merge)(params, { method: 'del' }));
}

function doSuccessfullRequest(result) {
  return _bluebird2.default.resolve(result);
}

function doUnsuccessfullRequest(result) {
  return _bluebird2.default.reject(result);
}

function getQueryString(field, url) {
  var href = url || window.location.href;
  var reg = new RegExp('[?&#]' + field + '=([^&#]*)', 'i');
  var string = reg.exec(href);
  return string ? string[1] : null;
}

function getQueryStrings(fields, url) {
  var href = url || window.location.href;
  var getParam = (0, _util.bindTrailingArgs)(getQueryString, href);
  var result = {};
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = fields[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var field = _step2.value;

      result[field] = getParam(field);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return result;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/httpmanager/lib/index.js
 ** module id = 179
 ** module chunks = 0
 **/